import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Versions from "../../components/Shared/Versions/Versions";
import { RouteConstants } from "../../constants";
import styles from "./AuthLayout.module.css";

const AuthLayout = () => {
  const { pathname } = useLocation();
  const isLoginPage = pathname === RouteConstants.LOGIN_PATH;
  return (
    <div
      className={`${styles.wrapper} h-100 overflow-auto d-flex flex-column align-items-center justify-content-center`}
    >
      <Outlet />
      {isLoginPage && (
        <small
          style={{
            position: "fixed",
            right: "5px",
            bottom: "5px",
            color: "#828282",
          }}
        >
          <Versions />
        </small>
      )}
    </div>
  );
};

export default AuthLayout;
